<template>
<div>
  <v-layout>
    <NewGroup v-on:created="created($event)" />
    <router-link :to="{ name:'related-group-type'}" class="dropdown-item">
      <v-btn>
        <span>{{ $t('related.group_types') }}</span>
      </v-btn>
    </router-link>
  </v-layout>
  <v-container fluid grid-list-md>
    <v-app id="inspire">
      <v-data-table :headers="headers" :items="relatedGroup" class="elevation-10">
        <template v-slot:items="props">
          <td>{{ props.item.id }}</td>
          <td>{{ props.item.name }}</td>
          <td>{{ props.item.code }}</td>
          <td>{{ getTypeName(props.item['type_id']) }}</td>
          <td>
            <ViewEditGroup :group.sync="props.item">
              <v-btn slot="activator" small icon>
                <v-icon small fab block color="grey darken-1" style="color: #efefef">search</v-icon>
              </v-btn>
            </ViewEditGroup>
            <v-btn @click="deleteSchema(props.item.id)" small icon>
              <v-icon small fab block color="orange darken-3" style="color: #efefef">delete</v-icon>
            </v-btn>
          </td>
        </template>
      </v-data-table>
    </v-app>
  </v-container>

</div>
</template>
<script>
import NewType from "./NewGroupType"
import ViewEditGroup from "./ViewEditGroup"
import NewGroup from './NewGroup'
import http from '@/plugins/http'

export default {
  components: {
    NewType,
    ViewEditGroup,
    NewGroup
  },
  computed: {
    relatedGroup() {
      return this.$store.state.relatedGroup
    },
    relatedGroupTypes() {
      return this.$store.state.relatedGroupTypes
    },
  },
  data() {
    return {
      name: "",
      headers: [{
          text: 'ID',
          value: "id",
          width: "50px"
        },
        {
          text: this.$t('related.name'),
          value: 'name'
        },
        {
          text: this.$t('related.code'),
          value: 'related_schema_id'
        },
        {
          text: this.$t('related.group_type'),
          value: 'related_group_code'
        },
        {
          text: this.$t('related.actions'),
        }
      ],
      relatedSchemas: []
    }
  },
  methods: {
    created(relatedGroup) {
      let relatedGroups = this.relatedGroup
      relatedGroups.push(relatedGroup)
      this.$store.commit('setRelatedGroup', relatedGroups)
    },
    deleteSchema(id) {
      this.$confirm(this.$t('related.delete_confirmation'))
        .then(res => {
          if (res) {
            http.delete("related/group/" + id).then(() => {
              let relatedGroup = this.relatedGroup.filter(el => el.id != id)
              this.$store.commit('setRelatedGroup', relatedGroup)
            })
          }
        })
    },
    getTypeName(id) {
      let type = this.relatedGroupTypes.find(el => el.id == id)
      return type ? type.name : ""
    }
  },
  created() {
    if (this.relatedGroup.length == 0)
      return this.$store.dispatch('loadRelatedGroup')
    if (this.relatedGroupTypes.length == 0)
      return this.$store.dispatch('loadRelatedGroupTypes')
  }
}
</script>

<style>
.loading-circle {
  margin: 20px;
}

.apexcharts-canvas.dark {
  background: transparent !important;
}

.filtr-active {
  background-color: green !important;
}
</style>
